import * as api from "app/api/planning"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import { handleError } from "app/redux/errorHandler/errorHandler.saga"
import * as actions from "./hrUnavailabilitiesOverview.actions"

export function* getHrUnavailabitiesOverview(action: actions.GetHrUnavailabilitiesOverviewAction): SagaIterator {
  try {
    const { data } = yield call(api.getHrUnavailabilitiesOverview, action.payload.params)
    yield put(actions.getHrUnavailabilitiesOverviewSuccess(data))
  } catch (e) {
    yield put(actions.getHrUnavailabilitiesOverviewFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* hrUnavailabilitiesSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getHrUnavailabitiesOverview)
}
